import { Anchor, Text } from "@mantine/core";
import { useSelector } from "src/redux/hooks";
import { openBase64 } from "src/utils";

import { type TMedHistoryRow } from "./MedHistory.types";

interface Props {
  row: TMedHistoryRow;
}

const MedHistoryRow = ({ row }: Props) => {
  const uppercase = useSelector(state => state.preferencesSlice.uppercase);
  if (typeof row === "string") {
    return (
      <Text color="text" transform={uppercase ? "uppercase" : "none"}>
        {row}
      </Text>
    );
  }
  if (row.type === "text") {
    return (
      <Text color="text" transform={uppercase ? "uppercase" : "none"}>
        {row.text}
      </Text>
    );
  }
  if (row.type === "attachment") {
    const handleOpenFile = () => {
      if (row.b64 && row.filetype && row.filename) {
        openBase64(row.b64, row.filetype, row.filename, false);
      }
    };
    return <Anchor onClick={handleOpenFile}>{row.filename}</Anchor>;
  }
  return <></>;
};

export default MedHistoryRow;
